import { EcommerceItem, useAnalytics } from './useAnalytics';
import { useCallback } from 'react';

export const useProductTracking = () => {
  const { trackViewItem, trackViewItemList, trackSelectItem } = useAnalytics();

  const trackProductView = useCallback(
    (product: EcommerceItem) => {
      trackViewItem({
        currency: 'EUR',
        value: product.price || 0,
        items: [product],
      });
    },
    [trackViewItem]
  );

  const trackProductListView = useCallback(
    (products: Array<EcommerceItem>, listId: string, listName: string) => {
      trackViewItemList({
        item_list_id: listId,
        item_list_name: listName,
        items: products,
      });
    },
    [trackViewItemList]
  );

  const trackProductSelection = useCallback(
    (product: EcommerceItem, listId: string, listName: string) => {
      trackSelectItem({
        item_list_id: listId,
        item_list_name: listName,
        items: [product],
      });
    },
    [trackSelectItem]
  );

  return {
    trackProductView,
    trackProductListView,
    trackProductSelection,
  };
};
